

export function getFolderStructure(data: ModuleObject[]):FolderObject {
    let baseFolder:FolderObject = {
        name:'base',
        children:[],
        includes: new Set(data.map(moduleObject=> moduleObject.module))
    }
    data.forEach(moduleObject=>moduleObject.nameSplit = moduleObject.module.split('/'));

    //If there is only one module name, no need for folders
    if(baseFolder.includes.size<=1) {
        baseFolder.modules = data.filter(moduleObject=>baseFolder.includes.has(moduleObject.module))
    } else {
        baseFolder.children = getNextFolders(baseFolder.includes, data, '');
    }
    return baseFolder;
}

function getNextFolders(moduleNamesInFolder:Set<string>, data: ModuleObject[], currentPath: string): FolderObject[] {
    if(moduleNamesInFolder.size<=1) return [];

    const modulesInDirectory = data.filter(moduleObject=>moduleNamesInFolder.has(moduleObject.module))
    let subFolders = new Set<string>();

    //add subFolderName and remove part of the directory used from moduleObject
    modulesInDirectory.forEach(moduleObject=> {
        if(moduleObject.nameSplit && moduleObject.nameSplit.length>0){
            subFolders.add(moduleObject.nameSplit[0]);
            moduleObject.nameSplit.splice(0,1);
        }
    })
    
    //create NewFolderObject for each subFolder and push to array
    let nextFolders:FolderObject[] = [];
    subFolders.forEach(subFolder=>{
        const subFolderPath = currentPath+subFolder;
        let newFolder:FolderObject = {
            name:subFolder,
            children:[],
            includes: new Set(data.filter(moduleObject=>moduleObject.module===subFolderPath || moduleObject.module.startsWith(subFolderPath+'/')).map(moduleObject=>moduleObject.module))
        }

        //if only one module in folder, add module to modules and combine any future directory names
        if(newFolder.includes.size<=1) {
            newFolder.name = [...newFolder.includes][0].replace(currentPath,"")
            newFolder.modules = data.filter(moduleObject => moduleObject.module.startsWith(subFolderPath))

        //else split further into new subfolders
        } else {
            newFolder.children = getNextFolders(newFolder.includes, data,subFolderPath+'/');

            //if only 1 subfolder, combine folders
            if(newFolder.children.length===1 && setsEqual(newFolder.includes,newFolder.children[0].includes)) {
                newFolder.name += '/'+newFolder.children[0].name;
                newFolder.children = newFolder.children[0].children;
            }
            
            //add unfoldered modules
            let modulesInSubFolders = new Set<string>();
            newFolder.children.forEach(folder=>modulesInSubFolders = new Set([...modulesInSubFolders,...folder.includes]))
            if(modulesInSubFolders.size!== newFolder.includes.size) {
                newFolder.modules = []
                newFolder.includes.forEach(moduleName=>{
                    if(!modulesInSubFolders.has(moduleName)) {
                        newFolder.modules?.push(...data.filter(moduleObject=>moduleObject.module === moduleName))
                    }
                })
            }
        }
        nextFolders.push(newFolder);
    })
    return nextFolders;
}

function setsEqual (set1: Set<string>, set2:Set<string>): boolean {
    return set1.size === set2.size && [...set1].every(element=>set2.has(element))
}